import React from 'react'

const Reaponsivefooter = () => {
  return (
   <div className="res-footer fixed-bottom bg-white border-top responsive-footer">
  <div className="d-flex justify-content-between text-center px-2">
    
    <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
      <i className="fa-solid fa-house fs-5"></i>
      <div className="small">Home</div>
    </div>

    <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
      <i className="fa-solid fa-cart-shopping fs-5"></i>
      <div className="small">Shopping</div>
    </div>

    <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
      <i className="fa-solid fa-magnifying-glass fs-5"></i>
      <div className="small">Search</div>
    </div>

    <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
      <i className="fa-regular fa-user fs-5"></i>
      <div className="small">Account</div>
    </div>

    <div className="footer-cmt pointer-cursor d-flex flex-column align-items-center">
      <i className="fa-solid fa-heart fs-5"></i>
      <div className="small">Wishlist</div>
    </div>

  </div>
</div>

  )
}

export default Reaponsivefooter
